var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import get from 'lodash/get';
import set from 'lodash/set';
import React from 'react';
export var withFilteredProps = Component => {
  var Wrapper = props => {
    var disabledAttributes = props.disabledAttributes,
      restProps = __rest(props, ["disabledAttributes"]);
    var internalRef = props.internalRef;
    if (disabledAttributes) {
      var filteredProps = React.useMemo(() => {
        var tempProps = Object.assign({}, props);
        Object.keys(disabledAttributes).forEach(key_ => {
          var value = disabledAttributes[key_];
          var key = key_.replace(/:/g, '.');
          if (typeof value === 'boolean') {
            set(tempProps, key, null);
          }
          if (Array.isArray(value)) {
            var array = get(tempProps, key);
            if (array) {
              array = array.filter(element => {
                return !value.includes(element.id);
              });
              set(tempProps, key, array);
            }
          }
        });
        return tempProps;
      }, [props]);
      return _jsx(_Fragment, {
        children: _jsx(Component, Object.assign({}, filteredProps, {
          internalRef: internalRef
        }))
      });
    } else return _jsx(Component, Object.assign({}, restProps));
  };
  Wrapper.genericRendererKey = Component.genericRendererKey;
  Wrapper.isAirSection = Component.isAirSection;
  return Wrapper;
};